import {
  CREATE_SIGNUP_GENERATOR_SUCCESS,
  CREATE_SIGNUP_GENERATOR_ERROR,
  CLEAR_SIGNUP_GENERATOR_STATUS,
  DETELE_SIGNUP_GENERATOR_SUCCESS,
  DETELE_SIGNUP_GENERATOR_ERROR,
  FETCH_SIGNUP_GENERATOR,
  FETCH_SIGNUP_GENERATOR_ERROR,
  CLEAR_SIGNUP_GENERATOR,
  UPDATE_SIGNUP_GENERATOR_SUCCESS,
  UPDATE_SIGNUP_GENERATOR_ERROR,
  CLEAR_UPDATE_SIGNUP_GENERATOR_STATUS,
  FETCH_SIGNUP_SUBSCRIBERS_LIST,
  FETCH_SIGNUP_SUBSCRIBERS_LIST_ERROR,
  FETCH_SIGNUP_SUBSCRIBERS_LIST_CLEAR,
  FETCH_SIGNUP_SUBSCRIBERS_CSV,
  FETCH_SIGNUP_SUBSCRIBERS_CSV_ERROR,
  CLEAR_FETCH_SIGNUP_SUBSCRIBERS_CSV,

} from 'redux/signup-generator/types';

const initialState = {
  createSignupGeneratorSuccess: null,
  createSignupGeneratorError: null,
  deleteSignupGeneratorSuccess: null,
  deleteSignupGeneratorError: null,
  signupGenerator: null,
  signupGeneratorError: null,
  updateSignupGeneratorSuccess: null,
  updateSignupGeneratorError: null,
  signupSubscribersList: null,
  signupSubscribersListError: null,
  signupSibscribersCsv: null,
  signupSibscribersCsvError: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case CREATE_SIGNUP_GENERATOR_SUCCESS:
      return {
        ...state,
        createSignupGeneratorSuccess: action.payload.data,
        createSignupGeneratorError: null,
      };
    case CREATE_SIGNUP_GENERATOR_ERROR:
      return {
        ...state,
        createSignupGeneratorSuccess: null,
        createSignupGeneratorError: action.payload.data,
      };
    case CLEAR_SIGNUP_GENERATOR_STATUS:
      return {
        ...state,
        createSignupGeneratorSuccess: null,
        createSignupGeneratorError: null,
        deleteSignupGeneratorSuccess: null,
        deleteSignupGeneratorError: null,
      };
    case DETELE_SIGNUP_GENERATOR_SUCCESS:
      return {
        ...state,
        deleteSignupGeneratorSuccess: action.payload ? Boolean(!action.payload.data) : null,
        deleteSignupGeneratorError: null,
        signupGenerator: null,
        signupGeneratorError: null,
      };
    case DETELE_SIGNUP_GENERATOR_ERROR:
      return {
        ...state,
        deleteSignupGeneratorSuccess: null,
        deleteSignupGeneratorError: action.payload ? Boolean(!action.payload.data) : null,
      };
    case FETCH_SIGNUP_GENERATOR:
      return {
        ...state,
        signupGenerator: action.payload.data,
        signupGeneratorError: null,
      };
    case FETCH_SIGNUP_GENERATOR_ERROR:
      return {
        ...state,
        signupGenerator: null,
        signupGeneratorError: action.payload.data,
      };
    case CLEAR_SIGNUP_GENERATOR:
      return {
        ...state,
        signupGenerator: null,
        signupGeneratorError: null,
      };
    case UPDATE_SIGNUP_GENERATOR_SUCCESS:
      return {
        ...state,
        updateSignupGeneratorSuccess: action.payload.data,
        updateSignupGeneratorError: null,
      };
    case UPDATE_SIGNUP_GENERATOR_ERROR:
      return {
        ...state,
        updateSignupGeneratorSuccess: null,
        updateSignupGeneratorError: action.payload.data,
      };
    case CLEAR_UPDATE_SIGNUP_GENERATOR_STATUS:
      return {
        ...state,
        updateSignupGeneratorSuccess: null,
        updateSignupGeneratorError: null,
      };
    case FETCH_SIGNUP_SUBSCRIBERS_LIST:
      return {
        ...state,
        signupSubscribersList: action.payload.data,
        signupSubscribersListError: null,
      };
    case FETCH_SIGNUP_SUBSCRIBERS_LIST_ERROR:
      return {
        ...state,
        signupSubscribersList: null,
        signupSubscribersListError: action.payload.data,
      };
    case FETCH_SIGNUP_SUBSCRIBERS_LIST_CLEAR:
      return {
        ...state,
        signupSubscribersList: null,
        signupSubscribersListError: null,
      };
    case FETCH_SIGNUP_SUBSCRIBERS_CSV:
      return {
        ...state,
        signupSibscribersCsv: action.payload.data,
        signupSibscribersCsvError: null,
      };
    case FETCH_SIGNUP_SUBSCRIBERS_CSV_ERROR:
      return {
        ...state,
        signupSibscribersCsv: null,
        signupSibscribersCsvError: action.payload.data,
      };
    case CLEAR_FETCH_SIGNUP_SUBSCRIBERS_CSV:
      return {
        ...state,
        signupSibscribersCsv: null,
        signupSibscribersCsvError: null,
      };
    default:
      return state;
  }
};
